import { ILoadingAction } from 'models/Loading'
import { action, payload } from 'ts-action'

export type TLoadingActions =
  | ReturnType<typeof SetFavoriteLoading>
  | ReturnType<typeof SetNotificationPreferenceLoading>

export const SetFavoriteLoading = action(
  'SetFavoriteLoading',
  payload<ILoadingAction>(),
)

export const SetNotificationPreferenceLoading = action(
  'SetNotificationPreferenceLoading',
  payload<ILoadingAction>(),
)
